<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h3>Opret kunde for {{ currentDepartment.name }} - [{{ currentDepartment.code }}]</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <app-customer-masterdata [errorMessage]="errorMessage()" (isValidChanged)="updateCanSave($event)"
        (formSubmitted)="saveCustomer($event)"></app-customer-masterdata>
</div>

<div class="modal-footer bg-transparent">
    <button class="btn btn-success float-end" [disabled]="!canSaveCustomer()" (click)="submitForm()">
        @if(isCreatingCustomer())
        {
        <div class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Opretter...</span>
        </div>
        } Opret Kunde
    </button>
</div>
